

import React from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Slidesmooth from './Slidsmooth';

import './swiper.css';

// Import required modules
import { Pagination, Autoplay } from 'swiper/modules';

const Swiper1 = () => {
    return (
        <>
            {/* <Swiper
                pagination={{
                    dynamicBullets: true,
                }}
                autoplay={{
                    delay: 2500, // 2.5 seconds delay
                    disableOnInteraction: false,
                }}
                modules={[Pagination, Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide><img src="assets/img/s2-01.png" alt="" /></SwiperSlide>
                <SwiperSlide><img src="assets/img/s2-02.png" alt="" /></SwiperSlide>
                <SwiperSlide><img src="assets/img/s2-03.png" alt="" /></SwiperSlide>
                <SwiperSlide><img src="assets/img/s2-04.png" alt="" /></SwiperSlide>
                <SwiperSlide><img src="assets/img/s2-05.png" alt="" /></SwiperSlide>
                <SwiperSlide><img src="assets/img/s2-06.png" alt="" /></SwiperSlide>
             
            </Swiper> */}
            <Slidesmooth />
        </>
    );
}

export default Swiper1;
